/**
 * Global Meta Pixel Tracking Function
 * @param {string} eventName - Standard (e.g., 'CompleteRegistration') or Custom event name
 * @param {Object} params - Additional data (e.g., { value: 10, currency: 'USD' })
 */
export const trackPixelEvent = (eventName, params = {}) => {
  if (window.fbq) {
    window.fbq('track', eventName, params);
  } else {
    console.warn(`Meta Pixel not initialized. Event "${eventName}" not tracked.`);
  }
};